import { Orientation } from '../../constants/Orientation';
import { Pricing } from '../../constants/Pricing';
import { getParameterByName } from '../../utils/utils';
export const normalizeOrientation = orientation => {
  switch (orientation) {
    case Orientation.Vertical:
    case Orientation.Portrait:
      return Orientation.Portrait;
    case Orientation.Horizontal:
    case Orientation.Landscape:
      return Orientation.Landscape;
    case Orientation.All:
    default:
      return '';
  }
};
export const normalizeRestriction = restrictContent => restrictContent ? 'unrestricted' : '';
const normalizePricing = pricing => pricing === Pricing.All ? '' : pricing ? pricing : Pricing.Free;
const normalizeK12Restriction = restrictK12 => restrictK12 ? 'k12unrestricted' : '';
export const parseFilters = filters => {
  const {
    orientation,
    color,
    restrictContent,
    pricing,
    restrictK12
  } = filters;
  return [normalizeOrientation(orientation), color, normalizeRestriction(restrictContent), normalizePricing(pricing), normalizeK12Restriction(restrictK12)].filter(a => a).join(',');
};
export const parsePaging = data => {
  const {
    nextPage
  } = data;
  return {
    cursor: nextPage ? nextPage.replace(/^\/public/, '') : null,
    size: nextPage ? parseInt(getParameterByName(nextPage, 'pageSize'), 10) : null
  };
};